import { isIP } from 'is-ip';

export function requiredRule(message = 'Field is required') {
  return value => !!value || value === 0 || message;
}

export function maxLengthRule(
  minLength = 3,
  message = `Name must be less than {{minLength}} characters`
) {
  return value =>
    (value && value.length <= minLength) ||
    message.replace('{{minLength}}', minLength);
}

export function minLengthRule(
  maxLength = 3,
  message = `Name must be more than {{maxLength}} characters`
) {
  return value =>
    (value && value.length >= maxLength) ||
    message.replace('{{maxLength}}', maxLength);
}

export function atLeastChoices(
  choices = 1,
  message = 'Must choose at least {{choices}} elements'
) {
  return value => {
    return (
      (value && value.length >= choices) ||
      message.replace('{{choices}}', choices)
    );
  };
}

export function isIpAddress(message = 'You must give a valid IP') {
  return value => {
    return isIP(value) || message;
  };
}
